import React from 'react';
import '../Cards.css';
import CardItem from '../CardItem';

function Projectlithium() {
  window.scrollTo(0, 0)
  return (

    <div id='about' className='cards'>
      <h1>Project Lithium </h1>
      <h3 className="cards-description">When lockdown first started, I launched a website development firm to help small buisnesses. I developed websites focused on sharing buisnesses narratives with the world to boost their revenue. I used Shopify, html/css and Reactjs to build a variety of websites. 
      </h3>

      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>

            <CardItem
              src='images/attitude.png'
              text='Developed website with booking functionality for Badminton coach '
              label='Developed website for Badminton coach'
            />
            <CardItem
              src='images/cks.png'
              label="Client website"
              text='Developed website for Indian groceer to help with sales'
            />


          </ul>

        </div>
      </div>
    </div>


  )
}

export default Projectlithium
